
export const formatLiviCauseCode = (code: string, liviCauseCode: LiviCauseCode) => {
  if (!liviCauseCode) {
    return code;
  }
  return code + ' ' + liviCauseCode.categoryName;
};

/**
 * To provide bundled data for UI
 */
export interface BundledCauseCode {
  /**
   * Either third, detailed or category
   */
  determinedKonegisCauseCode: string;
  konegisCauseCode: KonegisCauseCode;
  liviCauseCode?: LiviCauseCode;
}

export interface KonegisCauseCode {
  categoryCode: string;
  detailedCategoryCode: string;
  thirdCategoryCode: string;
}

export interface LiviCauseCode {
  id: number;
  categoryCode: string;
  categoryName: string;
  validFrom: string;
}

export interface LiviDetailedCauseCode {
  id: number;
  detailedCategoryCode: string;
  detailedCategoryName: string;
  validFrom: string;
}

export interface LiviThirdCauseCode {
  id: number;
  thirdCategoryCode: string;
  thirdCategoryName: string;
  validFrom: string;
}
